package components.project.configuration.profitability

import it.neckar.lizergy.model.company.user.AccessRights.AccessRight
import it.neckar.lizergy.model.financial.currency.Money
import it.neckar.lizergy.model.price.ResolvedCompanyEarningsEntry

data class EarningsTableRow(
  /**
   * label and id of the checkbox
   * */
  val label: String,

  /**
   * Profit [Money] of a role
   * */
  val earningsCompanyEntry: ResolvedCompanyEarningsEntry,

  /**
   * the right of access to which the values can be accessed
   */
  val accessRight: AccessRight,
) {
  companion object {
    val allRowAccessRights: List<AccessRight> = listOf(
      AccessRight.ViewEarningsReferrerRow,
      AccessRight.ViewEarningsDistributionBlueprintRow,
      AccessRight.ViewEarningsDistributionQuoteRow,
      AccessRight.ViewEarningsTechnicalPlanningRoofRow,
      AccessRight.ViewEarningsTechnicalPlanningElectricRow,
      AccessRight.ViewEarningsRoofAssemblyRow,
      AccessRight.ViewEarningsScaffoldingAssemblyRow,
      AccessRight.ViewEarningsElectricityWorkRow,
      AccessRight.ViewEarningsBureaucracyRow,
    )
  }
}
